import type { SVGProps } from 'react';

export const KeyFillSFSymbolMedium = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 13.1185 24.4157"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="24.4157" opacity="0" width="13.1185" x="0" y="0" />{' '}
        <path
          d="M6.38261 0.0932165C2.82695 0.0932165 0 2.92192 0 6.45805C0 9.07954 1.5502 11.4071 3.98281 12.3823L3.98281 21.861C3.98281 22.1403 4.075 22.3838 4.28594 22.594L5.97129 24.2434C6.18828 24.4498 6.59589 24.4969 6.8537 24.2391L9.9371 21.1557C10.2072 20.8776 10.1957 20.4854 9.93358 20.2135L8.14686 18.4491L10.6447 15.9575C10.8971 15.6954 10.8988 15.3014 10.6287 15.0233L8.20233 12.5809C11.1303 11.3411 12.7572 9.1145 12.7572 6.45805C12.7572 2.9397 9.91073 0.0932165 6.38261 0.0932165ZM6.38261 5.86509C5.47617 5.86509 4.74999 5.13267 4.74999 4.23247C4.74999 3.32427 5.4664 2.60161 6.38261 2.60161C7.28105 2.60161 8.01523 3.32603 8.01523 4.23247C8.01523 5.13267 7.28105 5.86509 6.38261 5.86509Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
